import {getRouteApi} from "@tanstack/react-router";

export const usersRouteApi = getRouteApi("/_app/admin/users/");
